import { Component, Input, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-users-table',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit {

    users;
    @Input() firm;
  
    constructor(private alertController: AlertController, private apiService: ApiService, private globalService: GlobalService) { }
  
    ngOnInit() {
      this.GetData();
    }

    async GetData() {
      let data: any = await this.apiService.get(`firms/${this.firm.guid}/users`);
      if(data.success) this.users = data.data;
    }


    async resendSetupEmail(user: any) {
      const alert = await this.alertController.create({
        header: 'Resend Setup Email?',
        message: `Are you sure you would like to resend the setup email to ${user.display_name}?`,
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'secondary',
          }, {
            text: 'Okay',
            handler: async () => {
              let data: any = await this.apiService.post(`firms/${this.firm.guid}/users/${user.guid}/resend_setup_email`, {});
              this.globalService.presentToastMessage(data.message, data.success);
            }
          }
        ]
      });
      await alert.present();
    }


    async presentDeleteAlert(user) {
      const alert = await this.alertController.create({
        header: 'Are you sure?',
        subHeader: `Delete ` + user.display_name,
        message: `Are you sure you would like to delete ${user.display_name}`,
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              console.log('Confirm Cancel: blah');
            }
          }, {
            text: 'Okay',
            handler: () => {
              //Delete the firm
              this.apiService.delete(`users/${user.guid}`, null);
              user.deleted = true;
            }
          }
        ]
      });
      await alert.present();
  
      const { role } = await alert.onDidDismiss();
      console.log('onDidDismiss resolved with role', role);
  
    }


}
